export default __webpack_public_path__ + "assets/images/weather-app.png";